import { render, staticRenderFns } from "./PlayerName.vue?vue&type=template&id=61f0f61f&scoped=true&"
import script from "./PlayerName.vue?vue&type=script&lang=js&"
export * from "./PlayerName.vue?vue&type=script&lang=js&"
import style0 from "./PlayerName.vue?vue&type=style&index=0&id=61f0f61f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0f61f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
